// TODO Replace with tooltip from alembic
import { Tooltip } from '@chakra-ui/tooltip';
import { Button, ButtonText, IButton } from '@morressier/alembic';
import React, { ReactNode } from 'react';
import useAuthAccessQuery from 'src/hooks/useAuthAccessQuery';

const buttonTypes = ['button', 'text'] as const;
type IButtonType = (typeof buttonTypes)[number];

interface Props extends IButton {
  relation: string;
  entityType: string;
  entityId: string;
  as?: IButtonType;
  tooltipLabel?: ReactNode;
}

const ComponentMap: Record<IButtonType, React.FC<any>> = {
  button: Button,
  text: ButtonText
};

const ProtectedActionButton = ({
  children,
  relation,
  entityId,
  entityType,
  as = 'button',
  tooltipLabel = <span>You do not have permission to make this decision</span>,
  ...buttonProps
}: Props) => {
  const { isAllowed, isLoading } = useAuthAccessQuery({
    relation,
    entityType,
    entityId
  });

  const Component = ComponentMap[as];

  return isAllowed ? (
    <Component {...buttonProps}>{children}</Component>
  ) : (
    <Tooltip
      shouldWrapChildren={buttonProps?.shouldWrapChildren ?? true}
      isDisabled={isLoading}
      hasArrow
      label={tooltipLabel}
      fontSize="md"
      placement="top"
    >
      <Component disabled variant={buttonProps.variant} isLoading={isLoading}>
        {children}
      </Component>
    </Tooltip>
  );
};

export default ProtectedActionButton;
